import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "M9.608 14.431a.618.618 0 0 0 1.055-.036l3.176-5.633 1.358 2.75a.62.62 0 0 0 .555.348h1.876c.343 0 .62-.281.62-.628a.624.624 0 0 0-.62-.629h-1.493l-1.704-3.454a.619.619 0 0 0-1.094-.03l-3.253 5.769-1.32-2.005a.62.62 0 0 0-.516-.28H6.372a.625.625 0 0 0-.62.629c0 .347.278.628.62.628h1.544z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#000",
      "fill-rule": "evenodd",
      d: "M20.27 4.861C18 2.436 14.335 2.381 12 4.696c-2.335-2.315-5.999-2.26-8.27.165-2.307 2.463-2.307 6.444 0 8.907L9.473 19.9a3.453 3.453 0 0 0 5.054 0l5.743-6.132c2.307-2.463 2.307-6.444 0-8.907m-7.53.866c1.835-1.96 4.795-1.96 6.63 0 1.852 1.978 1.852 5.197 0 7.175l-5.743 6.132a2.223 2.223 0 0 1-3.254 0L4.63 12.902c-1.852-1.978-1.852-5.197 0-7.175 1.835-1.96 4.796-1.96 6.63 0a1.01 1.01 0 0 0 1.48 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }